export function compareObjectsByValues<T>(o1: T, o2: T): boolean {
  let { keys } = Object;
  let getKey = (o: any, k: any) => typeof o[k] === 'string' ? (o[k] || '').trim() : o[k];
  let toNullIfEmpty = (v: any) => !v ? null : v;
  if (typeof o1 !== 'object' || typeof o2 !== 'object') return false;
  if (keys(o1).length !== keys(o2).length) return false;
  let isCompare = keys(o1)
    .map((key) => {
      return {
        name: key,
        isCompare: toNullIfEmpty(getKey(o1, key)) === toNullIfEmpty(getKey(o2, key)),
      };
    })
    .every((field) => field.isCompare);
  return isCompare;
}
